export default __webpack_public_path__ + "static/media/MCSW_Mission.1c1b31d9.pdf";